// extracted by mini-css-extract-plugin
export var section = "_2j-1";
export var topNav = "_2j-0";